<!-- Paginator -->
<div class="pagination-container bg-white">
  <mat-paginator
    class="bg-white"
    [length]="totalResults"
    [pageSize]="pageSize"
    [pageIndex]="pageIndex"
    [pageOffset]="pageOffset"
    [pageSizeOptions]="pageSizeOptions"
    (page)="onMatPageChange($event)"
    aria-label="Select page of transactions"
  >
  </mat-paginator>
</div>
